import { render } from "./SessionsEdit.vue?vue&type=template&id=95d66e82&scoped=true&ts=true"
import script from "./SessionsEdit.vue?vue&type=script&lang=ts"
export * from "./SessionsEdit.vue?vue&type=script&lang=ts"

import "./SessionsEdit.vue?vue&type=style&index=0&id=95d66e82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d66e82"]])

export default __exports__